import React from 'react';
import './card.css';
export function Card(props) {
    const {title} = props;
    return (
<div className="card" style={{width: '16rem !important'}}>
  <div className="card-body mi-service">
    <h5 className="card-title">{title}</h5>
    <h6 className="card-subtitle mb-2 text-muted"><hr/></h6>
    <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
  </div>
</div>
    )
}